import React from 'react';
import clsx from 'clsx';
import './CheckItem.css';
import { CloseIcon } from '../../assets/icons';

const CheckItem = ({ label, onClick, isClear }) => {
  return <div className={clsx('check-item', isClear && 'check-item-clear')}>
    {label}
    <button onClick={onClick}>
      <CloseIcon fill="#898892" />
    </button>
  </div>
}

export default CheckItem;
